var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center",class:_vm.divPadding},[_c('img',{staticClass:"h-10 w-auto mx-2 rounded-md",attrs:{"src":_vm.logo,"alt":"icon"}}),_vm._v(" "),_c('div',{staticClass:"inline-block font-semibold uppercase",class:_vm.textClass},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }